// R43/R44 — **THE ONE WAY THIS HOUSE GIVES A PAGE A TITLE IN ITS DOCUMENT OUTLINE.**
//
// A screen reader's first question about any page is "what page is this", and the answer it reads is
// the `<h1>`. Four pages on this site had none, and none of them looks wrong on screen:
//
//   - `/membership` (R43) opens on "Choose your membership" as an **h2**, because W1-5's own comment
//     says "the page renders exactly what the popup renders" and a popup heads itself with an h2. The
//     one page that asks her for money had no title in its outline.
//   - `/library`, `/magic-room` and `/astrology` (R44) are the three SCENE rooms. The library is a
//     photograph with floating shelves ("Lala's Bookshelf is no longer a giant title here — it is the
//     first floating shelf's vertical label"), the Magic Room is books on a table, the astrology page
//     is a rotating disc. **A room whose title is ART has no title in text**, and the first two
//     rendered NO HEADING OF ANY KIND — not one, in the entire document.
//
// TWO RULINGS ARE BUILT IN, AND BOTH ARE DELIBERATE.
//
// 1. **THE NAME IS DERIVED FROM `PAGE_TITLES`** (R31/R42), which is the roster that already names
//    every page for the tab, the bookmark and the share sheet. The name in the outline and the name
//    on the tab are one declaration, so a room cannot come to be called two things.
// 2. **IT IS RENDERED VISUALLY HIDDEN, SO NOTHING ON SCREEN CHANGES.** What these four pages LOOK
//    like is the owner's, and repairing an accessibility tree is not a licence to redesign her rooms.
//    `.visually-hidden` is a 1px clip and never `display: none`, which would take the heading back
//    out of the accessibility tree while looking identical. **One class comes off when she wants any
//    of them read on screen.**
//
// Props in, tree out, no hook — so `scripts/r44-form-rosters.mjs`' sibling gates can CALL it, and the
// rendered gate (`scripts/lib/document-outline.mjs`) measures what it actually did in a real browser.
import { PAGE_TITLES, type Page } from "../lib/pages";

export function PageOutlineTitle({ page }: { page: Page }) {
  return <h1 className="visually-hidden">{PAGE_TITLES[page]}</h1>;
}
